import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { useEffect, useState } from "react"
import { SlotsGalleryType } from "../types/slots-gallery.type"
import useWindowSize from "../utilities/use-window-size"
import Carousel from "./carousel"
import SlotGamePopup from "./slot-game-popup"
import { useLocation } from "@reach/router"
import { isMobile } from "react-device-detect"

const SlotsGallery = ({
  data,
  containerClass,
  showSectionTitle = true,
  showPlayButton = false,
  slidesToShow = 10,
  showReflection = true,
  mobileTwoRows = true,
  showSeeAll = true,
  onDownloadClick
}: SlotsGalleryType) => {
  const [rows, setRows] = useState(1)
  const { width, height } = useWindowSize()
  const [activeGameSlot, setActiveGameSlot] = useState(null)
  const { pathname } = useLocation()

  useEffect(() => {
    if (width <= 768 && mobileTwoRows) {
      setRows(2)
    } else {
      setRows(1)
    }
  }, [width, height])

  return (
    <>
      {showPlayButton &&
        <SlotGamePopup
          slot={activeGameSlot}
          onCloseClick={() => setActiveGameSlot(null)}
          onDownloadClick={onDownloadClick!}
        />
      }
      <div className={containerClass}>
        {showSectionTitle && (
          <div className='titles flex flex-col justify-center items-center p-10 xl:p-0'>
            <h3 className='text-white text-center font-bold mb-2 uppercase'>
              Featured Slots
            </h3>
            {pathname !== '/' &&
              <div className='sub-title text-gray-300 text-center text-2xl pb-5'>
                Select a Free Slot game & Start Spinning!
              </div>
            }
          </div>
        )}
        <Carousel
          rows={rows}
          containerClass='pr-10 pl-10'
          edgesFade={false}
          dots={true}
          showArrows={true}
          slidesToScroll={10}
          slidesToShow={slidesToShow}
          seeAll={
            showSeeAll ? (
              <li className='see-all relative'>
                <Link
                  to='/slot-games/'
                  className='text-white underline font-bold text-[16px]'
                >
                  SEE ALL
                </Link>
              </li>
            ) : (
              <></>
            )
          }
          data={data.slice(0, 17).map((item: any) => {
            if (item.slotIcon.localFile.childImageSharp.gatsbyImageData) {
              if (!item.compose__page || !item.compose__page[0]) return

              return (
                <div className='carousel-item hover-glow' key={Math.random()} aria-hidden="true">
                  <div className='item-links p-8 flex flex-col justify-center items-center space-y-2'>
                    {(item.gameIframeUrl || item.longGameIframeUrl?.longGameIframeUrl) && (showSectionTitle || showPlayButton) && (
                      <button
                        onClick={() => setActiveGameSlot(item)}
                        className='play-demo-button'
                      >
                        Play Demo
                      </button>
                    )}
                    {item.slotInfoLink && (
                      <Link
                        to={`/${item.compose__page[0].slug}/`}
                        className='slot-info block text-white text-2xl underline'
                      >
                        Slot Info
                      </Link>
                    )}
                  </div>
                  <GatsbyImage
                    className='item-img'
                    image={
                      getImage(
                        item.slotIcon.localFile.childImageSharp.gatsbyImageData
                      )!
                    }
                    alt={item.compose__page[0].title}
                  />
                  <Link
                    to={`/${item.compose__page[0].slug}/`}
                    className='mobile-click'
                  ></Link>
                  {showReflection && !isMobile && (
                    <GatsbyImage
                      image={
                        getImage(
                          item.slotIcon.localFile.childImageSharp.gatsbyImageData
                        )!
                      }
                      alt={item.compose__page[0].title}
                      className='reflection'
                    />
                  )}
                </div>
              )
            } else {
              return <div key={Math.random()}>{item}</div>
            }
          })}
          responsive={[
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: false,
              },
            },
            {
              breakpoint: 650,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false,
              },
            },
          ]}
        />
      </div>
    </>
  )
}

export default SlotsGallery
